// ------------------------------------------------------- //
// Sidebar Stories Viewer
// ------------------------------------------------------ //

jQuery(document).on('load turbolinks:load', function() {
    var storiesViewer = jQuery('[data-sidebar-stories-viewer]');
    var storiesTrigger = jQuery('[data-sidebar-stories-open]');
    var triggerRingElement = storiesTrigger.find('.sidebar-stories-trigger-ring');
    jQuery(document).off('keydown.sidebarStories');
    jQuery(document).off('visibilitychange.sidebarStories');

    if (!storiesViewer.length || !storiesTrigger.length) return;

    var storiesEndpointUrl = storiesTrigger.attr('data-sidebar-stories-url');
    if (!storiesEndpointUrl) return;

    var storiesItems = [];
    var currentStoryIndex = 0;
    var frameElement = storiesViewer.find('.sidebar-stories-frame');
    var mediaElement = storiesViewer.find('[data-sidebar-stories-media]');
    var headlineElement = storiesViewer.find('[data-sidebar-stories-headline]');
    var textElement = storiesViewer.find('[data-sidebar-stories-text]');
    var linkElement = storiesViewer.find('[data-sidebar-stories-link]');
    var indicatorsElement = storiesViewer.find('[data-sidebar-stories-indicators]');
    var previousButton = storiesViewer.find('[data-sidebar-stories-prev]');
    var nextButton = storiesViewer.find('[data-sidebar-stories-next]');

    var activeVideoElement = null;
    var imageProgressFrameId = null;
    var imageProgressTimeoutId = null;
    var imageProgressElapsedMs = 0;
    var imageProgressStartedAt = null;
    var videoAudioProbeIntervalId = null;

    var isSoundMuted = false;
    var isPausedByUser = false;
    var isPausedByVisibility = false;
    var isPausedByPointerHold = false;
    var activeVideoHasAudioTrack = true;
    var viewedStoryIds = {};
    var videoPreviewCache = {};
    var mediaContrastCache = {};
    var pointerHoldState = {
        pointerId: null,
        startTimeMs: 0,
        startX: 0,
        startY: 0,
        shouldResume: false
    };
    var POINTER_HOLD_THRESHOLD_MS = 220;
    var POINTER_TAP_MOVE_THRESHOLD_PX = 12;
    var CONTRAST_THRESHOLD = 0.42;
    var CONTRAST_SAMPLE_WIDTH = 24;
    var CONTRAST_SAMPLE_HEIGHT = 24;

    var defaultImageStoryDuration = parseInt(storiesViewer.attr('data-image-story-duration-ms'), 10);
    var imageStoryDurationMs = Number.isFinite(defaultImageStoryDuration) && defaultImageStoryDuration > 0 ? defaultImageStoryDuration : 10000; //10s by default
    var viewedStoryStorageKey = (window.gon && gon.user ? gon.user : 'anonymous') + '_sidebarStoriesViewedIds';

    function readViewedStories() {
        try {
            var rawValue = localStorage.getItem(viewedStoryStorageKey);
            var parsedValue = rawValue ? JSON.parse(rawValue) : [];
            if (!Array.isArray(parsedValue)) return {};

            return parsedValue.reduce(function(result, storyId) {
                if (storyId === null || storyId === undefined) return result;
                result[String(storyId)] = true;
                return result;
            }, {});
        } catch (error) {
            console.warn('Viewed stories state could not be read. Using default state.');
            return {};
        }
    }

    function writeViewedStories() {
        try {
            localStorage.setItem(viewedStoryStorageKey, JSON.stringify(Object.keys(viewedStoryIds)));
        } catch (error) {
            console.warn('Viewed stories state could not be saved.');
        }
    }

    function storyIdKey(story) {
        if (!story || story.id === undefined || story.id === null) return null;
        return String(story.id);
    }

    function currentStoryIds() {
        return storiesItems.map(function(story) { return storyIdKey(story); }).filter(Boolean);
    }

    function firstUnseenStoryIndex() {
        for (var index = 0; index < storiesItems.length; index += 1) {
            var storyKey = storyIdKey(storiesItems[index]);
            if (!storyKey || !viewedStoryIds[storyKey]) return index;
        }
        return -1;
    }

    function nextOpenStoryIndex() {
        var unseenIndex = firstUnseenStoryIndex();
        return unseenIndex >= 0 ? unseenIndex : 0;
    }

    function allStoriesViewed() {
        var ids = currentStoryIds();
        if (!ids.length) return false;
        return ids.every(function(storyKey) { return !!viewedStoryIds[storyKey]; });
    }

    function ensureTriggerImageElement(elementTag) {
        var desiredTag = (elementTag || 'img').toLowerCase();
        var imageElement = storiesTrigger.find('.sidebar-stories-trigger-image');
        if (imageElement.length && imageElement.prop('tagName').toLowerCase() === desiredTag) return imageElement;
        if (imageElement.length) imageElement.remove();

        var fallback = storiesTrigger.find('.sidebar-stories-trigger-fallback');
        if (fallback.length) {
            fallback.replaceWith('<' + desiredTag + ' class="sidebar-stories-trigger-image"></' + desiredTag + '>');
            return storiesTrigger.find('.sidebar-stories-trigger-image');
        }

        storiesTrigger.find('.sidebar-stories-trigger-ring').append('<' + desiredTag + ' class="sidebar-stories-trigger-image"></' + desiredTag + '>');
        return storiesTrigger.find('.sidebar-stories-trigger-image');
    }

    function setTriggerFallbackPreview() {
        var imageElement = storiesTrigger.find('.sidebar-stories-trigger-image');
        var fallback = storiesTrigger.find('.sidebar-stories-trigger-fallback');

        if (imageElement.length) imageElement.hide();
        if (!fallback.length) {
            storiesTrigger.find('.sidebar-stories-trigger-ring').append('<span class="sidebar-stories-trigger-fallback"></span>');
            fallback = storiesTrigger.find('.sidebar-stories-trigger-fallback');
        }
        fallback.show();
    }

    function setTriggerImagePreview(sourceUrl) {
        if (!sourceUrl) {
            setTriggerFallbackPreview();
            return;
        }

        var imageElement = ensureTriggerImageElement('img');
        imageElement.attr('src', sourceUrl).show();
        storiesTrigger.find('.sidebar-stories-trigger-fallback').hide();
    }

    function setTriggerVideoPreview(story) {
        if (!story || !story.video_url) {
            setTriggerFallbackPreview();
            return;
        }

        var videoElement = ensureTriggerImageElement('video');
        var previewSeekTime = 2;

        videoElement
            .attr('src', story.video_url)
            .attr('muted', true)
            .attr('playsinline', true)
            .attr('preload', 'metadata')
            .prop('muted', true)
            .prop('playsInline', true)
            .show();

        storiesTrigger.find('.sidebar-stories-trigger-fallback').hide();

        videoElement.off('.sidebarStoriesTriggerPreview');
        videoElement.on('loadedmetadata.sidebarStoriesTriggerPreview', function() {
            var domVideo = videoElement.get(0);
            if (!domVideo) return;

            var seekTo = Number.isFinite(domVideo.duration) && domVideo.duration > 0 ? Math.min(previewSeekTime, domVideo.duration) : 0;
            try {
                domVideo.currentTime = seekTo;
            } catch (_error) {
                domVideo.pause();
            }
        });

        videoElement.on('seeked.sidebarStoriesTriggerPreview loadeddata.sidebarStoriesTriggerPreview canplay.sidebarStoriesTriggerPreview', function() {
            var domVideo = videoElement.get(0);
            if (!domVideo) return;
            domVideo.pause();
        });

        videoElement.on('error.sidebarStoriesTriggerPreview', function() {
            captureVideoThumbnail(story, function(thumbnailUrl) {
                if (thumbnailUrl) {
                    setTriggerImagePreview(thumbnailUrl);
                } else {
                    setTriggerFallbackPreview();
                }
            });
        });
    }

    function captureVideoThumbnail(story, callback) {
        var storyKey = storyIdKey(story);
        if (!story || !story.video_url) {
            callback(null);
            return;
        }

        if (storyKey && videoPreviewCache[storyKey]) {
            callback(videoPreviewCache[storyKey]);
            return;
        }

        var video = document.createElement('video');
        video.crossOrigin = 'anonymous';
        video.preload = 'metadata';
        video.muted = true;
        video.playsInline = true;

        var settled = false;
        var cleanup = function() {
            video.removeAttribute('src');
            video.load();
            video.onloadeddata = null;
            video.onloadedmetadata = null;
            video.onseeked = null;
            video.onerror = null;
        };

        var done = function(thumbnailData) {
            if (settled) return;
            settled = true;
            cleanup();
            callback(thumbnailData);
        };

        var snapshot = function() {
            try {
                var canvas = document.createElement('canvas');
                var width = video.videoWidth || 240;
                var height = video.videoHeight || 240;
                canvas.width = width;
                canvas.height = height;
                canvas.getContext('2d').drawImage(video, 0, 0, width, height);
                var thumbnail = canvas.toDataURL('image/png');
                if (storyKey) videoPreviewCache[storyKey] = thumbnail;
                done(thumbnail);
            } catch (error) {
                done(null);
            }
        };

        video.onloadedmetadata = function() {
            if (!Number.isFinite(video.duration) || video.duration <= 0.1) {
                snapshot();
                return;
            }

            try {
                video.currentTime = 0.1;
            } catch (error) {
                snapshot();
            }
        };

        video.onseeked = snapshot;
        video.onloadeddata = function() {
            if (video.currentTime >= 0.1 || !Number.isFinite(video.duration) || video.duration <= 0.1) snapshot();
        };
        video.onerror = function() { done(null); };
        video.src = story.video_url;
    }

    function refreshTriggerPreviewAndRing() {
        var nextStory = storiesItems[nextOpenStoryIndex()];

        storiesTrigger.toggleClass('is-all-viewed', allStoriesViewed());
        triggerRingElement.toggleClass('is-all-viewed', allStoriesViewed());

        if (!nextStory) {
            setTriggerFallbackPreview();
            return;
        }

        if (nextStory.image_url) {
            setTriggerImagePreview(nextStory.image_url);
            return;
        }

        if (nextStory.video_url) {
            setTriggerVideoPreview(nextStory);
            return;
        }

        setTriggerFallbackPreview();
    }

    function markStoryAsViewed(story) {
        var storyKey = storyIdKey(story);
        if (!storyKey || viewedStoryIds[storyKey]) return;

        viewedStoryIds[storyKey] = true;
        writeViewedStories();
        refreshTriggerPreviewAndRing();
    }

    viewedStoryIds = readViewedStories();

    function loadSidebarStories() {
        return jQuery.ajax({
            url: storiesEndpointUrl,
            method: 'GET',
            dataType: 'json',
            cache: false
        }).then(function(data) {
            return Array.isArray(data) ? data : [];
        }, function() {
            console.warn('Sidebar stories could not be loaded.');
            return [];
        });
    }

    loadSidebarStories().then(function(items) {
        storiesItems = items;
        if (!storiesItems.length) return;

        storiesTrigger.prop('hidden', false);
        refreshTriggerPreviewAndRing();
    });

    function currentThemeMode() {
        return jQuery('html').attr('data-bs-theme') === 'dark' ? 'dark' : 'light';
    }

    function storyColorValue(colorObject) {
        if (!colorObject) return null;

        var mode = currentThemeMode();
        return mode === 'dark' ? (colorObject.dark || colorObject.light) : (colorObject.light || colorObject.dark);
    }

    function buildStoryBackground(background) {
        if (!background) return '';
        if (background.value) return background.value;

        var colors = (background.colors || []).map(function(color) {
            return storyColorValue(color);
        }).filter(function(color) {
            return !!color;
        });

        if (!colors.length) return '';
        if (background.type === 'color') return colors[0];
        if (background.type === 'radial') return 'radial-gradient(circle, ' + colors.join(', ') + ')';

        if (background.type === 'gradient' && background.start && background.end) {
            var angle = Math.atan2(background.end.y - background.start.y, background.end.x - background.start.x) * (180 / Math.PI) + 90;
            return 'linear-gradient(' + angle + 'deg, ' + colors.join(', ') + ')';
        }

        return colors[0];
    }

    function resetStoryTextContrastClasses() {
        headlineElement.removeClass('light-text dark-text');
        textElement.removeClass('light-text dark-text');
    }

    function applyStoryTextContrastClasses(isLightBackground) {
        var textClass = isLightBackground ? 'dark-text' : 'light-text';
        var oppositeClass = isLightBackground ? 'light-text' : 'dark-text';

        headlineElement.removeClass(oppositeClass).addClass(textClass);
        textElement.removeClass(oppositeClass).addClass(textClass);
    }

    function storyColorLuminanceFromRgb(red, green, blue) {
        function normalizeChannel(channel) {
            var value = channel / 255;
            return value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
        }

        var r = normalizeChannel(red);
        var g = normalizeChannel(green);
        var b = normalizeChannel(blue);

        return (0.2126 * r) + (0.7152 * g) + (0.0722 * b);
    }

    function parseRgbColorValue(colorValue) {
        if (!colorValue) return null;
        var normalizedColor = String(colorValue).trim();

        var shortHexMatch = normalizedColor.match(/^#([0-9a-f]{3})$/i);
        if (shortHexMatch) {
            var shortHex = shortHexMatch[1];
            return {
                r: parseInt(shortHex[0] + shortHex[0], 16),
                g: parseInt(shortHex[1] + shortHex[1], 16),
                b: parseInt(shortHex[2] + shortHex[2], 16)
            };
        }

        var longHexMatch = normalizedColor.match(/^#([0-9a-f]{6})$/i);
        if (longHexMatch) {
            var longHex = longHexMatch[1];
            return {
                r: parseInt(longHex.slice(0, 2), 16),
                g: parseInt(longHex.slice(2, 4), 16),
                b: parseInt(longHex.slice(4, 6), 16)
            };
        }

        var rgbMatch = normalizedColor.match(/^rgba?\(([^)]+)\)$/i);
        if (!rgbMatch) return null;

        var rgbValues = rgbMatch[1].split(',').map(function(channel) {
            return parseFloat(String(channel).trim());
        });

        if (rgbValues.length < 3 || rgbValues.slice(0, 3).some(function(value) { return Number.isNaN(value); })) return null;
        return { r: rgbValues[0], g: rgbValues[1], b: rgbValues[2] };
    }

    function storyBackgroundLuminance(story) {
        if (!story || !story.background || !Array.isArray(story.background.colors)) return null;

        var colors = story.background.colors.map(function(colorObject) {
            return storyColorValue(colorObject);
        }).filter(Boolean);

        if (!colors.length) return null;

        var luminances = colors.map(function(colorValue) {
            var rgbColor = parseRgbColorValue(colorValue);
            if (!rgbColor) return null;
            return storyColorLuminanceFromRgb(rgbColor.r, rgbColor.g, rgbColor.b);
        }).filter(function(value) {
            return Number.isFinite(value);
        });

        if (!luminances.length) return null;
        return luminances.reduce(function(sum, value) { return sum + value; }, 0) / luminances.length;
    }

    function sampleCanvasUpperHalfLuminance(canvas, context) {
        var sampleWidth = canvas.width;
        var sampleHeight = Math.max(1, Math.floor(canvas.height / 2));
        var pixels = context.getImageData(0, 0, sampleWidth, sampleHeight).data;
        var luminanceSum = 0;
        var count = 0;

        for (var pixelIndex = 0; pixelIndex < pixels.length; pixelIndex += 4) {
            luminanceSum += storyColorLuminanceFromRgb(pixels[pixelIndex], pixels[pixelIndex + 1], pixels[pixelIndex + 2]);
            count += 1;
        }

        if (!count) return null;
        return luminanceSum / count;
    }

    function updateContrastFromLuminance(luminanceValue) {
        if (!Number.isFinite(luminanceValue)) return;
        applyStoryTextContrastClasses(luminanceValue > CONTRAST_THRESHOLD);
    }

    function sampleImageContrast(story) {
        if (!story || !story.image_url) return;
        var imageUrl = story.image_url;
        if (mediaContrastCache[imageUrl] !== undefined) {
            updateContrastFromLuminance(mediaContrastCache[imageUrl]);
            return;
        }

        var parsedImageUrl;
        try {
            parsedImageUrl = new URL(imageUrl, window.location.href);
        } catch (_error) {
            console.warn('Story image could not be prepared for contrast check.', _error);
            return;
        }

        var image = new Image();
        if (parsedImageUrl.origin !== window.location.origin) {
            image.crossOrigin = 'anonymous';
        }

        image.onload = function() {
            try {
                var canvas = document.createElement('canvas');
                var context = canvas.getContext('2d');
                if (!context) return;

                canvas.width = CONTRAST_SAMPLE_WIDTH;
                canvas.height = CONTRAST_SAMPLE_HEIGHT;
                context.drawImage(image, 0, 0, canvas.width, canvas.height);

                var luminanceValue = sampleCanvasUpperHalfLuminance(canvas, context);
                if (!Number.isFinite(luminanceValue)) return;

                mediaContrastCache[imageUrl] = luminanceValue;
                var activeStory = getCurrentStory();
                if (!activeStory || activeStory.image_url !== imageUrl) return;
                updateContrastFromLuminance(luminanceValue);
            } catch (_error) {
                console.warn('Story image contrast check was skipped.', _error);
            }
        };

        image.onerror = function() {
            // Keep existing/default (or fallback) text style if sampling fails.
        };

        image.src = imageUrl;
    }

    function sampleVideoContrast(videoElement) {
        if (!videoElement) return;
        var videoUrl = videoElement.currentSrc || videoElement.src;
        if (!videoUrl) return;

        if (mediaContrastCache[videoUrl] !== undefined) {
            updateContrastFromLuminance(mediaContrastCache[videoUrl]);
            return;
        }

        try {
            if (!videoElement.videoWidth || !videoElement.videoHeight || videoElement.readyState < 2) return;

            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            if (!context) return;

            canvas.width = CONTRAST_SAMPLE_WIDTH;
            canvas.height = CONTRAST_SAMPLE_HEIGHT;
            context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

            var luminanceValue = sampleCanvasUpperHalfLuminance(canvas, context);
            if (!Number.isFinite(luminanceValue)) return;

            mediaContrastCache[videoUrl] = luminanceValue;
            if (videoElement !== activeVideoElement) return;
            updateContrastFromLuminance(luminanceValue);
        } catch (_error) {
            console.warn('Story video contrast check was skipped.', _error);
        }
    }

    function safeStoryLink(rawLink) {
        if (!rawLink) return null;

        var normalizedLink = String(rawLink).trim();
        if (!normalizedLink) return null;

        if (/^(https?:\/\/|mailto:|tel:)/i.test(normalizedLink)) return normalizedLink;
        if (/^\/\//.test(normalizedLink)) return 'https:' + normalizedLink;
        if (/^\//.test(normalizedLink)) return normalizedLink;

        // Accept plain domains like "example.com", "example.com/path", "example.com?x=1" by normalizing to https.
        if (/^[a-z0-9][a-z0-9.-]*\.[a-z]{2,}([/?#].*)?$/i.test(normalizedLink)) {
            return 'https://' + normalizedLink;
        }

        return null;
    }

    function hasStory(index) {
        return index >= 0 && index < storiesItems.length;
    }

    function hasNextStory() {
        return hasStory(currentStoryIndex + 1);
    }

    function hasPreviousStory() {
        return hasStory(currentStoryIndex - 1);
    }

    function isVideoStory(story) {
        return !!(story && story.video_url);
    }

    function isImageStory(story) {
        return !!(story && !story.video_url);
    }

    function getCurrentStory() {
        return storiesItems[currentStoryIndex] || null;
    }

    function clearImageStoryTimers() {
        if (imageProgressTimeoutId) {
            window.clearTimeout(imageProgressTimeoutId);
            imageProgressTimeoutId = null;
        }

        if (imageProgressFrameId) {
            window.cancelAnimationFrame(imageProgressFrameId);
            imageProgressFrameId = null;
        }
    }

    function clearVideoStoryBindings() {
        if (videoAudioProbeIntervalId) {
            window.clearInterval(videoAudioProbeIntervalId);
            videoAudioProbeIntervalId = null;
        }

        if (!activeVideoElement) return;

        jQuery(activeVideoElement).off('.sidebarStoriesVideo');
        activeVideoElement.pause();
        activeVideoElement = null;
        activeVideoHasAudioTrack = true;
    }

    function cleanupCurrentStoryPlayback() {
        clearImageStoryTimers();
        clearVideoStoryBindings();
        imageProgressElapsedMs = 0;
        imageProgressStartedAt = null;
    }

    function normalizeProgress(progressValue) {
        if (!Number.isFinite(progressValue)) return 0;
        if (progressValue <= 0) return 0;
        if (progressValue >= 1) return 1;
        return progressValue;
    }

    function setIndicatorProgress(progressValue) {
        var normalizedProgress = normalizeProgress(progressValue);

        indicatorsElement.find('.sidebar-stories-indicator').each(function() {
            var indicator = jQuery(this);
            var indicatorIndex = parseInt(indicator.attr('data-story-indicator-index'), 10);
            var fillElement = indicator.find('.sidebar-stories-indicator-fill');
            var fillProgress = 0;

            indicator.removeClass('is-active is-completed');

            if (indicatorIndex < currentStoryIndex) {
                indicator.addClass('is-completed');
                fillProgress = 1;
            } else if (indicatorIndex === currentStoryIndex) {
                indicator.addClass('is-active');
                fillProgress = normalizedProgress;
            }

            fillElement.css('width', (fillProgress * 100) + '%');
        });
    }

    function renderIndicators() {
        indicatorsElement.empty();

        storiesItems.forEach(function(_story, index) {
            indicatorsElement.append(
                '<span class="sidebar-stories-indicator" data-story-indicator-index="' + index + '">' +
                    '<span class="sidebar-stories-indicator-fill"></span>' +
                '</span>'
            );
        });

        setIndicatorProgress(0);
    }

    function setControlsVisibility() {
        previousButton.prop('disabled', !hasPreviousStory());
        nextButton.prop('disabled', !hasNextStory());
    }

    function updateVideoControlButtons() {
        var controls = mediaElement.find('.sidebar-stories-media-controls');
        if (!controls.length) return;

        var playPauseIcon = controls.find('[data-story-toggle-play] i');
        var audioButton = controls.find('[data-story-toggle-audio]');
        var audioIcon = controls.find('[data-story-toggle-audio] i');
        var isPlaying = activeVideoElement && !activeVideoElement.paused && !activeVideoElement.ended;

        playPauseIcon.attr('class', isPlaying ? 'fas fa-pause' : 'fas fa-play');
        audioButton.prop('disabled', !activeVideoHasAudioTrack);
        audioButton.toggleClass('d-none', !activeVideoHasAudioTrack);
        audioIcon.attr('class', !activeVideoHasAudioTrack || isSoundMuted ? 'fas fa-volume-mute' : 'fas fa-volume-up');
    }

    function detectVideoAudioTrack(videoElement, forceDecision) {
        if (!videoElement) return { determined: true, hasAudio: true };

        if (typeof videoElement.mozHasAudio === 'boolean') {
            return { determined: true, hasAudio: videoElement.mozHasAudio };
        }

        if (videoElement.audioTracks && typeof videoElement.audioTracks.length === 'number') {
            return { determined: true, hasAudio: videoElement.audioTracks.length > 0 };
        }

        if (typeof videoElement.webkitAudioDecodedByteCount === 'number') {
            if (videoElement.webkitAudioDecodedByteCount > 0) {
                return { determined: true, hasAudio: true };
            }

            if (forceDecision || videoElement.currentTime > 0.35 || videoElement.ended) {
                return { determined: true, hasAudio: false };
            }

            return { determined: false, hasAudio: false };
        }

        return { determined: true, hasAudio: true };
    }

    function updateVideoAudioTrackState(videoElement, forceDecision) {
        if (!videoElement) return;

        var detection = detectVideoAudioTrack(videoElement, !!forceDecision);
        if (!detection.determined) return;

        activeVideoHasAudioTrack = detection.hasAudio;
        updateVideoControlButtons();
    }

    function startVideoAudioTrackProbe(videoElement) {
        if (!videoElement) return;

        if (videoAudioProbeIntervalId) {
            window.clearInterval(videoAudioProbeIntervalId);
            videoAudioProbeIntervalId = null;
        }

        var attempts = 0;
        var maxAttempts = 30;

        var probe = function(forceDecision) {
            var detection = detectVideoAudioTrack(videoElement, !!forceDecision);
            if (!detection.determined) return false;

            activeVideoHasAudioTrack = detection.hasAudio;
            updateVideoControlButtons();
            return true;
        };

        if (probe(false)) return;

        videoAudioProbeIntervalId = window.setInterval(function() {
            attempts += 1;
            if (probe(attempts >= maxAttempts)) {
                window.clearInterval(videoAudioProbeIntervalId);
                videoAudioProbeIntervalId = null;
                return;
            }

            if (attempts >= maxAttempts) {
                window.clearInterval(videoAudioProbeIntervalId);
                videoAudioProbeIntervalId = null;
            }
        }, 100);
    }

    function renderStory() {
        var story = getCurrentStory();
        if (!story) return;
        markStoryAsViewed(story);
        resetStoryTextContrastClasses();
        updateContrastFromLuminance(storyBackgroundLuminance(story));

        var fallbackBackground = buildStoryBackground(story.background);

        frameElement.css('background', fallbackBackground || '#1a2233');
        mediaElement.empty();

        if (isVideoStory(story)) {
            mediaElement.append(
                '<video class="sidebar-stories-media-video" src="' + story.video_url + '" preload="metadata" playsinline></video>' +
                '<div class="sidebar-stories-media-controls">' +
                    '<button type="button" class="sidebar-stories-media-btn" data-story-toggle-audio aria-label="Toggle volume">' +
                        '<i class="fas fa-volume-up"></i>' +
                    '</button>' +
                    '<button type="button" class="sidebar-stories-media-btn" data-story-toggle-play aria-label="Toggle play and pause">' +
                        '<i class="fas fa-pause"></i>' +
                    '</button>' +
                '</div>'
            );
        } else if (story.image_url) {
            mediaElement.append('<img class="sidebar-stories-media-image" src="' + story.image_url + '" alt="">');
            sampleImageContrast(story);
        } else {
            mediaElement.append('<div class="sidebar-stories-media-fallback"></div>');
        }

        headlineElement.text(story.headline || '').toggle(!!story.headline);
        textElement.text(story.text || '').toggle(!!story.text);

        var storyLink = safeStoryLink(story.link);
        if (storyLink) {
            linkElement.attr('href', storyLink);
            linkElement.attr('target', '_blank');
            linkElement.text(story.link_text || 'Open');
            linkElement.prop('hidden', false);
        } else {
            linkElement.prop('hidden', true);
            linkElement.attr('href', '#');
            linkElement.removeAttr('target');
            linkElement.text('');
        }

        renderIndicators();
        setControlsVisibility();
    }

    function closeStoriesViewer() {
        cleanupCurrentStoryPlayback();
        isPausedByPointerHold = false;
        storiesViewer.prop('hidden', true).attr('aria-hidden', 'true');
        jQuery('body').removeClass('sidebar-stories-open');
    }

    function goToNextStoryOrClose() {
        if (hasNextStory()) {
            currentStoryIndex += 1;
            isPausedByUser = false;
            renderStory();
            startCurrentStoryPlayback();
            return;
        }

        closeStoriesViewer();
    }

    function goToPreviousStory() {
        if (!hasPreviousStory()) return;

        currentStoryIndex -= 1;
        isPausedByUser = false;
        renderStory();
        startCurrentStoryPlayback();
    }

    function goToNextStory() {
        if (!hasNextStory()) return;

        currentStoryIndex += 1;
        isPausedByUser = false;
        renderStory();
        startCurrentStoryPlayback();
    }

    function startImageStoryPlayback(resumeFromElapsed) {
        var elapsedAtStart = Number.isFinite(resumeFromElapsed) ? resumeFromElapsed : 0;
        imageProgressElapsedMs = Math.max(0, Math.min(imageStoryDurationMs, elapsedAtStart));
        imageProgressStartedAt = Date.now() - imageProgressElapsedMs;

        clearImageStoryTimers();

        var remainingDuration = Math.max(0, imageStoryDurationMs - imageProgressElapsedMs);
        imageProgressTimeoutId = window.setTimeout(function() {
            setIndicatorProgress(1);
            goToNextStoryOrClose();
        }, remainingDuration);

        function animateImageProgress() {
            if (!storiesViewer.is(':visible')) return;

            var elapsed = Date.now() - imageProgressStartedAt;
            imageProgressElapsedMs = Math.max(0, Math.min(imageStoryDurationMs, elapsed));
            setIndicatorProgress(imageProgressElapsedMs / imageStoryDurationMs);

            if (imageProgressElapsedMs >= imageStoryDurationMs) return;
            imageProgressFrameId = window.requestAnimationFrame(animateImageProgress);
        }

        animateImageProgress();
    }

    function pauseImageStoryPlayback() {
        if (!isImageStory(getCurrentStory())) return;

        if (imageProgressStartedAt) {
            imageProgressElapsedMs = Math.max(0, Math.min(imageStoryDurationMs, Date.now() - imageProgressStartedAt));
        }

        clearImageStoryTimers();
    }

    function setupVideoStoryPlayback() {
        activeVideoElement = mediaElement.find('video').get(0);
        if (!activeVideoElement) return;

        var videoElement = activeVideoElement;
        activeVideoHasAudioTrack = false;
        videoElement.loop = false;
        videoElement.muted = isSoundMuted;
        videoElement.defaultMuted = isSoundMuted;

        function syncVideoProgress() {
            if (!videoElement || !Number.isFinite(videoElement.duration) || videoElement.duration <= 0) {
                setIndicatorProgress(0);
                return;
            }

            setIndicatorProgress(videoElement.currentTime / videoElement.duration);
        }

        jQuery(videoElement)
            .off('.sidebarStoriesVideo')
            .on('loadedmetadata.sidebarStoriesVideo durationchange.sidebarStoriesVideo canplay.sidebarStoriesVideo timeupdate.sidebarStoriesVideo', function() {
                updateVideoAudioTrackState(videoElement, false);
                sampleVideoContrast(videoElement);
                syncVideoProgress();
            })
            .on('play.sidebarStoriesVideo pause.sidebarStoriesVideo', function() {
                updateVideoControlButtons();
            })
            .on('ended.sidebarStoriesVideo', function() {
                setIndicatorProgress(1);
                goToNextStoryOrClose();
            });

        if (videoElement.audioTracks && typeof videoElement.audioTracks.addEventListener === 'function') {
            videoElement.audioTracks.addEventListener('addtrack', function() {
                updateVideoAudioTrackState(videoElement, true);
            });
            videoElement.audioTracks.addEventListener('removetrack', function() {
                updateVideoAudioTrackState(videoElement, true);
            });
        }

        setIndicatorProgress(0);
        startVideoAudioTrackProbe(videoElement);
        updateVideoControlButtons();

        var autoplayPromise = videoElement.play();
        if (autoplayPromise && typeof autoplayPromise.catch === 'function') {
            autoplayPromise.catch(function() {
                // Browser blocked autoplay with sound; keep controls visible for manual start.
                isPausedByUser = true;
                updateVideoControlButtons();
            });
        }
    }

    function startCurrentStoryPlayback() {
        cleanupCurrentStoryPlayback();

        var story = getCurrentStory();
        if (!story) return;

        if (isVideoStory(story)) {
            setupVideoStoryPlayback();
        } else {
            startImageStoryPlayback(0);
        }
    }

    function openStoriesViewer(index) {
        if (!hasStory(index)) return;

        currentStoryIndex = index;
        isPausedByUser = false;
        isPausedByVisibility = false;

        storiesViewer.prop('hidden', false).attr('aria-hidden', 'false');
        jQuery('body').addClass('sidebar-stories-open');

        renderStory();
        startCurrentStoryPlayback();
    }

    function pauseCurrentStoryByVisibility() {
        if (storiesViewer.prop('hidden')) return;

        isPausedByVisibility = true;

        var story = getCurrentStory();
        if (isVideoStory(story) && activeVideoElement && !activeVideoElement.paused) {
            activeVideoElement.pause();
        }

        if (isImageStory(story)) {
            pauseImageStoryPlayback();
        }
    }

    function resumeCurrentStoryByVisibility() {
        if (storiesViewer.prop('hidden') || !isPausedByVisibility) return;

        var story = getCurrentStory();
        if (!story) return;

        isPausedByVisibility = false;

        if (isVideoStory(story) && activeVideoElement && !isPausedByUser) {
            activeVideoElement.play().catch(function() {
                isPausedByUser = true;
                updateVideoControlButtons();
            });
            return;
        }

        if (isImageStory(story)) {
            startImageStoryPlayback(imageProgressElapsedMs);
        }
    }

    function resetPointerHoldState() {
        pointerHoldState.pointerId = null;
        pointerHoldState.startTimeMs = 0;
        pointerHoldState.startX = 0;
        pointerHoldState.startY = 0;
        pointerHoldState.shouldResume = false;
    }

    function isInsideMediaControls(target) {
        return jQuery(target).closest('.sidebar-stories-media-controls').length > 0;
    }

    function isInteractiveFrameTarget(target) {
        var node = jQuery(target);
        if (!node.length) return false;
        if (isInsideMediaControls(target)) return true;
        if (node.closest('.sidebar-stories-link').length > 0) return true;
        if (node.closest('a, button, input, select, textarea, label').length > 0) return true;
        return false;
    }

    function pauseCurrentStoryByPointerHold() {
        if (storiesViewer.prop('hidden')) return;

        var story = getCurrentStory();
        if (!story) return;

        if (isVideoStory(story)) {
            pointerHoldState.shouldResume = !!(activeVideoElement && !activeVideoElement.paused && !isPausedByVisibility);
            if (pointerHoldState.shouldResume) {
                activeVideoElement.pause();
                isPausedByPointerHold = true;
            }
            return;
        }

        if (isImageStory(story)) {
            pointerHoldState.shouldResume = !isPausedByVisibility;
            if (pointerHoldState.shouldResume) {
                pauseImageStoryPlayback();
                isPausedByPointerHold = true;
            }
        }
    }

    function resumeCurrentStoryByPointerHold() {
        if (!isPausedByPointerHold) return;

        var story = getCurrentStory();
        if (!story) {
            isPausedByPointerHold = false;
            return;
        }

        if (isVideoStory(story)) {
            if (!isPausedByUser && !isPausedByVisibility && pointerHoldState.shouldResume && activeVideoElement) {
                activeVideoElement.play().catch(function() {
                    isPausedByUser = true;
                }).finally(function() {
                    updateVideoControlButtons();
                });
            }
            isPausedByPointerHold = false;
            return;
        }

        if (isImageStory(story) && !isPausedByVisibility && pointerHoldState.shouldResume) {
            startImageStoryPlayback(imageProgressElapsedMs);
        }

        isPausedByPointerHold = false;
    }

    storiesTrigger.off('click.sidebarStories').on('click.sidebarStories', function(event) {
        event.preventDefault();
        openStoriesViewer(nextOpenStoryIndex());
    });

    storiesViewer.find('[data-sidebar-stories-close]').off('click.sidebarStories').on('click.sidebarStories', function(event) {
        event.preventDefault();
        closeStoriesViewer();
    });

    previousButton.off('click.sidebarStories').on('click.sidebarStories', function(event) {
        event.preventDefault();
        goToPreviousStory();
    });

    nextButton.off('click.sidebarStories').on('click.sidebarStories', function(event) {
        event.preventDefault();
        goToNextStory();
    });

    storiesViewer.off('click.sidebarStoriesControls', '[data-story-toggle-audio]').on('click.sidebarStoriesControls', '[data-story-toggle-audio]', function(event) {
        event.preventDefault();
        if (!activeVideoHasAudioTrack) return;

        isSoundMuted = !isSoundMuted;
        if (activeVideoElement) {
            activeVideoElement.muted = isSoundMuted;
            activeVideoElement.defaultMuted = isSoundMuted;
        }

        updateVideoControlButtons();
    });

    storiesViewer.off('click.sidebarStoriesControls', '[data-story-toggle-play]').on('click.sidebarStoriesControls', '[data-story-toggle-play]', function(event) {
        event.preventDefault();

        if (!activeVideoElement) return;

        if (activeVideoElement.paused || activeVideoElement.ended) {
            isPausedByUser = false;
            activeVideoElement.play().catch(function() {
                isPausedByUser = true;
            }).finally(function() {
                updateVideoControlButtons();
            });
            return;
        }

        isPausedByUser = true;
        activeVideoElement.pause();
        updateVideoControlButtons();
    });

    function handleStoryLinkInteraction(event) {
        var storyLinkHref = jQuery(this).attr('href');
        if (!storyLinkHref || storyLinkHref === '#') {
            event.preventDefault();
            event.stopPropagation();
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        var targetValue = jQuery(this).attr('target') || '_blank';
        var openedWindow = window.open(storyLinkHref, targetValue, 'noopener,noreferrer');
        if (!openedWindow && targetValue === '_self') {
            window.location.assign(storyLinkHref);
        }
    }

    linkElement.off('pointerdown.sidebarStoriesLink click.sidebarStoriesLink')
        .on('pointerdown.sidebarStoriesLink', function(event) {
            event.stopPropagation();
        })
        .on('click.sidebarStoriesLink', handleStoryLinkInteraction);

    storiesViewer.off('click.sidebarStoriesLink', '[data-sidebar-stories-link]')
        .on('click.sidebarStoriesLink', '[data-sidebar-stories-link]', handleStoryLinkInteraction);

    frameElement.off('pointerdown.sidebarStories pointerup.sidebarStories pointercancel.sidebarStories').on('pointerdown.sidebarStories', function(event) {
        if (storiesViewer.prop('hidden')) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (isInteractiveFrameTarget(event.target)) return;

        pointerHoldState.pointerId = event.pointerId;
        pointerHoldState.startTimeMs = Date.now();
        pointerHoldState.startX = event.clientX;
        pointerHoldState.startY = event.clientY;
        pointerHoldState.shouldResume = false;

        pauseCurrentStoryByPointerHold();

        if (event.currentTarget && typeof event.currentTarget.setPointerCapture === 'function') {
            try {
                event.currentTarget.setPointerCapture(event.pointerId);
            } catch (_error) {
                console.warn('Story interaction fallback was used.', _error);
            }
        }
    }).on('pointerup.sidebarStories', function(event) {
        if (pointerHoldState.pointerId !== event.pointerId) return;

        var durationMs = Date.now() - pointerHoldState.startTimeMs;
        var deltaX = Math.abs(event.clientX - pointerHoldState.startX);
        var deltaY = Math.abs(event.clientY - pointerHoldState.startY);
        var hasMoved = deltaX > POINTER_TAP_MOVE_THRESHOLD_PX || deltaY > POINTER_TAP_MOVE_THRESHOLD_PX;
        var isHold = durationMs >= POINTER_HOLD_THRESHOLD_MS;
        var shouldNavigate = !hasMoved && !isHold && !isInteractiveFrameTarget(event.target);

        resumeCurrentStoryByPointerHold();

        if (shouldNavigate) {
            var frameRect = event.currentTarget.getBoundingClientRect();
            var isLeftHalf = (event.clientX - frameRect.left) < (frameRect.width / 2);
            if (isLeftHalf) {
                goToPreviousStory();
            } else {
                goToNextStory();
            }
        }

        resetPointerHoldState();
    }).on('pointercancel.sidebarStories', function(event) {
        if (pointerHoldState.pointerId !== event.pointerId) return;
        resumeCurrentStoryByPointerHold();
        resetPointerHoldState();
    });

    jQuery(document).off('keydown.sidebarStories').on('keydown.sidebarStories', function(event) {
        if (storiesViewer.prop('hidden')) return;

        if (event.key === 'Escape') {
            closeStoriesViewer();
            return;
        }

        if (event.key === 'ArrowRight') {
            goToNextStory();
            return;
        }

        if (event.key === 'ArrowLeft') {
            goToPreviousStory();
        }
    });

    jQuery(document).off('visibilitychange.sidebarStories').on('visibilitychange.sidebarStories', function() {
        if (document.hidden) {
            pauseCurrentStoryByVisibility();
            return;
        }

        resumeCurrentStoryByVisibility();
    });
});
// ------------------------------------------------------- //
// Sidebar Stories Viewer
// ------------------------------------------------------ //

jQuery(document).on('load turbolinks:load', function() {
    var storiesViewer = jQuery('[data-sidebar-stories-viewer]');
    var storiesTrigger = jQuery('[data-sidebar-stories-open]');
    var triggerRingElement = storiesTrigger.find('.sidebar-stories-trigger-ring');
    jQuery(document).off('keydown.sidebarStories');
    jQuery(document).off('visibilitychange.sidebarStories');

    if (!storiesViewer.length || !storiesTrigger.length) return;

    var storiesEndpointUrl = storiesTrigger.attr('data-sidebar-stories-url');
    if (!storiesEndpointUrl) return;

    var storiesItems = [];
    var currentStoryIndex = 0;
    var frameElement = storiesViewer.find('.sidebar-stories-frame');
    var mediaElement = storiesViewer.find('[data-sidebar-stories-media]');
    var headlineElement = storiesViewer.find('[data-sidebar-stories-headline]');
    var textElement = storiesViewer.find('[data-sidebar-stories-text]');
    var linkElement = storiesViewer.find('[data-sidebar-stories-link]');
    var indicatorsElement = storiesViewer.find('[data-sidebar-stories-indicators]');
    var previousButton = storiesViewer.find('[data-sidebar-stories-prev]');
    var nextButton = storiesViewer.find('[data-sidebar-stories-next]');

    var activeVideoElement = null;
    var imageProgressFrameId = null;
    var imageProgressTimeoutId = null;
    var imageProgressElapsedMs = 0;
    var imageProgressStartedAt = null;
    var videoAudioProbeIntervalId = null;

    var isSoundMuted = false;
    var isPausedByUser = false;
    var isPausedByVisibility = false;
    var isPausedByPointerHold = false;
    var activeVideoHasAudioTrack = true;
    var viewedStoryIds = {};
    var videoPreviewCache = {};
    var mediaContrastCache = {};
    var pointerHoldState = {
        pointerId: null,
        startTimeMs: 0,
        startX: 0,
        startY: 0,
        shouldResume: false
    };
    var POINTER_HOLD_THRESHOLD_MS = 220;
    var POINTER_TAP_MOVE_THRESHOLD_PX = 12;
    var CONTRAST_THRESHOLD = 0.42;
    var CONTRAST_SAMPLE_WIDTH = 24;
    var CONTRAST_SAMPLE_HEIGHT = 24;

    var defaultImageStoryDuration = parseInt(storiesViewer.attr('data-image-story-duration-ms'), 10);
    var imageStoryDurationMs = Number.isFinite(defaultImageStoryDuration) && defaultImageStoryDuration > 0 ? defaultImageStoryDuration : 10000; //10s by default
    var viewedStoryStorageKey = (window.gon && gon.user ? gon.user : 'anonymous') + '_sidebarStoriesViewedIds';

    function readViewedStories() {
        try {
            var rawValue = localStorage.getItem(viewedStoryStorageKey);
            var parsedValue = rawValue ? JSON.parse(rawValue) : [];
            if (!Array.isArray(parsedValue)) return {};

            return parsedValue.reduce(function(result, storyId) {
                if (storyId === null || storyId === undefined) return result;
                result[String(storyId)] = true;
                return result;
            }, {});
        } catch (error) {
            console.warn('Viewed stories state could not be read. Using default state.');
            return {};
        }
    }

    function writeViewedStories() {
        try {
            localStorage.setItem(viewedStoryStorageKey, JSON.stringify(Object.keys(viewedStoryIds)));
        } catch (error) {
            console.warn('Viewed stories state could not be saved.');
        }
    }

    function storyIdKey(story) {
        if (!story || story.id === undefined || story.id === null) return null;
        return String(story.id);
    }

    function currentStoryIds() {
        return storiesItems.map(function(story) { return storyIdKey(story); }).filter(Boolean);
    }

    function firstUnseenStoryIndex() {
        for (var index = 0; index < storiesItems.length; index += 1) {
            var storyKey = storyIdKey(storiesItems[index]);
            if (!storyKey || !viewedStoryIds[storyKey]) return index;
        }
        return -1;
    }

    function nextOpenStoryIndex() {
        var unseenIndex = firstUnseenStoryIndex();
        return unseenIndex >= 0 ? unseenIndex : 0;
    }

    function allStoriesViewed() {
        var ids = currentStoryIds();
        if (!ids.length) return false;
        return ids.every(function(storyKey) { return !!viewedStoryIds[storyKey]; });
    }

    function ensureTriggerImageElement(elementTag) {
        var desiredTag = (elementTag || 'img').toLowerCase();
        var imageElement = storiesTrigger.find('.sidebar-stories-trigger-image');
        if (imageElement.length && imageElement.prop('tagName').toLowerCase() === desiredTag) return imageElement;
        if (imageElement.length) imageElement.remove();

        var fallback = storiesTrigger.find('.sidebar-stories-trigger-fallback');
        if (fallback.length) {
            fallback.replaceWith('<' + desiredTag + ' class="sidebar-stories-trigger-image"></' + desiredTag + '>');
            return storiesTrigger.find('.sidebar-stories-trigger-image');
        }

        storiesTrigger.find('.sidebar-stories-trigger-ring').append('<' + desiredTag + ' class="sidebar-stories-trigger-image"></' + desiredTag + '>');
        return storiesTrigger.find('.sidebar-stories-trigger-image');
    }

    function setTriggerFallbackPreview() {
        var imageElement = storiesTrigger.find('.sidebar-stories-trigger-image');
        var fallback = storiesTrigger.find('.sidebar-stories-trigger-fallback');

        if (imageElement.length) imageElement.hide();
        if (!fallback.length) {
            storiesTrigger.find('.sidebar-stories-trigger-ring').append('<span class="sidebar-stories-trigger-fallback"></span>');
            fallback = storiesTrigger.find('.sidebar-stories-trigger-fallback');
        }
        fallback.show();
    }

    function setTriggerImagePreview(sourceUrl) {
        if (!sourceUrl) {
            setTriggerFallbackPreview();
            return;
        }

        var imageElement = ensureTriggerImageElement('img');
        imageElement.attr('src', sourceUrl).show();
        storiesTrigger.find('.sidebar-stories-trigger-fallback').hide();
    }

    function setTriggerVideoPreview(story) {
        if (!story || !story.video_url) {
            setTriggerFallbackPreview();
            return;
        }

        var videoElement = ensureTriggerImageElement('video');
        var previewSeekTime = 2;

        videoElement
            .attr('src', story.video_url)
            .attr('muted', true)
            .attr('playsinline', true)
            .attr('preload', 'metadata')
            .prop('muted', true)
            .prop('playsInline', true)
            .show();

        storiesTrigger.find('.sidebar-stories-trigger-fallback').hide();

        videoElement.off('.sidebarStoriesTriggerPreview');
        videoElement.on('loadedmetadata.sidebarStoriesTriggerPreview', function() {
            var domVideo = videoElement.get(0);
            if (!domVideo) return;

            var seekTo = Number.isFinite(domVideo.duration) && domVideo.duration > 0 ? Math.min(previewSeekTime, domVideo.duration) : 0;
            try {
                domVideo.currentTime = seekTo;
            } catch (_error) {
                domVideo.pause();
            }
        });

        videoElement.on('seeked.sidebarStoriesTriggerPreview loadeddata.sidebarStoriesTriggerPreview canplay.sidebarStoriesTriggerPreview', function() {
            var domVideo = videoElement.get(0);
            if (!domVideo) return;
            domVideo.pause();
        });

        videoElement.on('error.sidebarStoriesTriggerPreview', function() {
            captureVideoThumbnail(story, function(thumbnailUrl) {
                if (thumbnailUrl) {
                    setTriggerImagePreview(thumbnailUrl);
                } else {
                    setTriggerFallbackPreview();
                }
            });
        });
    }

    function captureVideoThumbnail(story, callback) {
        var storyKey = storyIdKey(story);
        if (!story || !story.video_url) {
            callback(null);
            return;
        }

        if (storyKey && videoPreviewCache[storyKey]) {
            callback(videoPreviewCache[storyKey]);
            return;
        }

        var video = document.createElement('video');
        video.crossOrigin = 'anonymous';
        video.preload = 'metadata';
        video.muted = true;
        video.playsInline = true;

        var settled = false;
        var cleanup = function() {
            video.removeAttribute('src');
            video.load();
            video.onloadeddata = null;
            video.onloadedmetadata = null;
            video.onseeked = null;
            video.onerror = null;
        };

        var done = function(thumbnailData) {
            if (settled) return;
            settled = true;
            cleanup();
            callback(thumbnailData);
        };

        var snapshot = function() {
            try {
                var canvas = document.createElement('canvas');
                var width = video.videoWidth || 240;
                var height = video.videoHeight || 240;
                canvas.width = width;
                canvas.height = height;
                canvas.getContext('2d').drawImage(video, 0, 0, width, height);
                var thumbnail = canvas.toDataURL('image/png');
                if (storyKey) videoPreviewCache[storyKey] = thumbnail;
                done(thumbnail);
            } catch (error) {
                done(null);
            }
        };

        video.onloadedmetadata = function() {
            if (!Number.isFinite(video.duration) || video.duration <= 0.1) {
                snapshot();
                return;
            }

            try {
                video.currentTime = 0.1;
            } catch (error) {
                snapshot();
            }
        };

        video.onseeked = snapshot;
        video.onloadeddata = function() {
            if (video.currentTime >= 0.1 || !Number.isFinite(video.duration) || video.duration <= 0.1) snapshot();
        };
        video.onerror = function() { done(null); };
        video.src = story.video_url;
    }

    function refreshTriggerPreviewAndRing() {
        var nextStory = storiesItems[nextOpenStoryIndex()];

        storiesTrigger.toggleClass('is-all-viewed', allStoriesViewed());
        triggerRingElement.toggleClass('is-all-viewed', allStoriesViewed());

        if (!nextStory) {
            setTriggerFallbackPreview();
            return;
        }

        if (nextStory.image_url) {
            setTriggerImagePreview(nextStory.image_url);
            return;
        }

        if (nextStory.video_url) {
            setTriggerVideoPreview(nextStory);
            return;
        }

        setTriggerFallbackPreview();
    }

    function markStoryAsViewed(story) {
        var storyKey = storyIdKey(story);
        if (!storyKey || viewedStoryIds[storyKey]) return;

        viewedStoryIds[storyKey] = true;
        writeViewedStories();
        refreshTriggerPreviewAndRing();
    }

    viewedStoryIds = readViewedStories();

    function loadSidebarStories() {
        return jQuery.ajax({
            url: storiesEndpointUrl,
            method: 'GET',
            dataType: 'json',
            cache: false
        }).then(function(data) {
            return Array.isArray(data) ? data : [];
        }, function() {
            console.warn('Sidebar stories could not be loaded.');
            return [];
        });
    }

    loadSidebarStories().then(function(items) {
        storiesItems = items;
        if (!storiesItems.length) return;

        storiesTrigger.prop('hidden', false);
        refreshTriggerPreviewAndRing();
    });

    function currentThemeMode() {
        return jQuery('html').attr('data-bs-theme') === 'dark' ? 'dark' : 'light';
    }

    function storyColorValue(colorObject) {
        if (!colorObject) return null;

        var mode = currentThemeMode();
        return mode === 'dark' ? (colorObject.dark || colorObject.light) : (colorObject.light || colorObject.dark);
    }

    function buildStoryBackground(background) {
        if (!background) return '';
        if (background.value) return background.value;

        var colors = (background.colors || []).map(function(color) {
            return storyColorValue(color);
        }).filter(function(color) {
            return !!color;
        });

        if (!colors.length) return '';
        if (background.type === 'color') return colors[0];
        if (background.type === 'radial') return 'radial-gradient(circle, ' + colors.join(', ') + ')';

        if (background.type === 'gradient' && background.start && background.end) {
            var angle = Math.atan2(background.end.y - background.start.y, background.end.x - background.start.x) * (180 / Math.PI) + 90;
            return 'linear-gradient(' + angle + 'deg, ' + colors.join(', ') + ')';
        }

        return colors[0];
    }

    function resetStoryTextContrastClasses() {
        headlineElement.removeClass('light-text dark-text');
        textElement.removeClass('light-text dark-text');
    }

    function applyStoryTextContrastClasses(isLightBackground) {
        var textClass = isLightBackground ? 'dark-text' : 'light-text';
        var oppositeClass = isLightBackground ? 'light-text' : 'dark-text';

        headlineElement.removeClass(oppositeClass).addClass(textClass);
        textElement.removeClass(oppositeClass).addClass(textClass);
    }

    function storyColorLuminanceFromRgb(red, green, blue) {
        function normalizeChannel(channel) {
            var value = channel / 255;
            return value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
        }

        var r = normalizeChannel(red);
        var g = normalizeChannel(green);
        var b = normalizeChannel(blue);

        return (0.2126 * r) + (0.7152 * g) + (0.0722 * b);
    }

    function parseRgbColorValue(colorValue) {
        if (!colorValue) return null;
        var normalizedColor = String(colorValue).trim();

        var shortHexMatch = normalizedColor.match(/^#([0-9a-f]{3})$/i);
        if (shortHexMatch) {
            var shortHex = shortHexMatch[1];
            return {
                r: parseInt(shortHex[0] + shortHex[0], 16),
                g: parseInt(shortHex[1] + shortHex[1], 16),
                b: parseInt(shortHex[2] + shortHex[2], 16)
            };
        }

        var longHexMatch = normalizedColor.match(/^#([0-9a-f]{6})$/i);
        if (longHexMatch) {
            var longHex = longHexMatch[1];
            return {
                r: parseInt(longHex.slice(0, 2), 16),
                g: parseInt(longHex.slice(2, 4), 16),
                b: parseInt(longHex.slice(4, 6), 16)
            };
        }

        var rgbMatch = normalizedColor.match(/^rgba?\(([^)]+)\)$/i);
        if (!rgbMatch) return null;

        var rgbValues = rgbMatch[1].split(',').map(function(channel) {
            return parseFloat(String(channel).trim());
        });

        if (rgbValues.length < 3 || rgbValues.slice(0, 3).some(function(value) { return Number.isNaN(value); })) return null;
        return { r: rgbValues[0], g: rgbValues[1], b: rgbValues[2] };
    }

    function storyBackgroundLuminance(story) {
        if (!story || !story.background || !Array.isArray(story.background.colors)) return null;

        var colors = story.background.colors.map(function(colorObject) {
            return storyColorValue(colorObject);
        }).filter(Boolean);

        if (!colors.length) return null;

        var luminances = colors.map(function(colorValue) {
            var rgbColor = parseRgbColorValue(colorValue);
            if (!rgbColor) return null;
            return storyColorLuminanceFromRgb(rgbColor.r, rgbColor.g, rgbColor.b);
        }).filter(function(value) {
            return Number.isFinite(value);
        });

        if (!luminances.length) return null;
        return luminances.reduce(function(sum, value) { return sum + value; }, 0) / luminances.length;
    }

    function sampleCanvasUpperHalfLuminance(canvas, context) {
        var sampleWidth = canvas.width;
        var sampleHeight = Math.max(1, Math.floor(canvas.height / 2));
        var pixels = context.getImageData(0, 0, sampleWidth, sampleHeight).data;
        var luminanceSum = 0;
        var count = 0;

        for (var pixelIndex = 0; pixelIndex < pixels.length; pixelIndex += 4) {
            luminanceSum += storyColorLuminanceFromRgb(pixels[pixelIndex], pixels[pixelIndex + 1], pixels[pixelIndex + 2]);
            count += 1;
        }

        if (!count) return null;
        return luminanceSum / count;
    }

    function updateContrastFromLuminance(luminanceValue) {
        if (!Number.isFinite(luminanceValue)) return;
        applyStoryTextContrastClasses(luminanceValue > CONTRAST_THRESHOLD);
    }

    function sampleImageContrast(story) {
        if (!story || !story.image_url) return;
        var imageUrl = story.image_url;
        if (mediaContrastCache[imageUrl] !== undefined) {
            updateContrastFromLuminance(mediaContrastCache[imageUrl]);
            return;
        }

        var parsedImageUrl;
        try {
            parsedImageUrl = new URL(imageUrl, window.location.href);
        } catch (_error) {
            console.warn('Story image could not be prepared for contrast check.', _error);
            return;
        }

        var image = new Image();
        if (parsedImageUrl.origin !== window.location.origin) {
            image.crossOrigin = 'anonymous';
        }

        image.onload = function() {
            try {
                var canvas = document.createElement('canvas');
                var context = canvas.getContext('2d');
                if (!context) return;

                canvas.width = CONTRAST_SAMPLE_WIDTH;
                canvas.height = CONTRAST_SAMPLE_HEIGHT;
                context.drawImage(image, 0, 0, canvas.width, canvas.height);

                var luminanceValue = sampleCanvasUpperHalfLuminance(canvas, context);
                if (!Number.isFinite(luminanceValue)) return;

                mediaContrastCache[imageUrl] = luminanceValue;
                var activeStory = getCurrentStory();
                if (!activeStory || activeStory.image_url !== imageUrl) return;
                updateContrastFromLuminance(luminanceValue);
            } catch (_error) {
                console.warn('Story image contrast check was skipped.', _error);
            }
        };

        image.onerror = function() {
            // Keep existing/default (or fallback) text style if sampling fails.
        };

        image.src = imageUrl;
    }

    function sampleVideoContrast(videoElement) {
        if (!videoElement) return;
        var videoUrl = videoElement.currentSrc || videoElement.src;
        if (!videoUrl) return;

        if (mediaContrastCache[videoUrl] !== undefined) {
            updateContrastFromLuminance(mediaContrastCache[videoUrl]);
            return;
        }

        try {
            if (!videoElement.videoWidth || !videoElement.videoHeight || videoElement.readyState < 2) return;

            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            if (!context) return;

            canvas.width = CONTRAST_SAMPLE_WIDTH;
            canvas.height = CONTRAST_SAMPLE_HEIGHT;
            context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

            var luminanceValue = sampleCanvasUpperHalfLuminance(canvas, context);
            if (!Number.isFinite(luminanceValue)) return;

            mediaContrastCache[videoUrl] = luminanceValue;
            if (videoElement !== activeVideoElement) return;
            updateContrastFromLuminance(luminanceValue);
        } catch (_error) {
            console.warn('Story video contrast check was skipped.', _error);
        }
    }

    function safeStoryLink(rawLink) {
        if (!rawLink) return null;

        var normalizedLink = String(rawLink).trim();
        if (!normalizedLink) return null;

        if (/^(https?:\/\/|mailto:|tel:)/i.test(normalizedLink)) return normalizedLink;
        if (/^\/\//.test(normalizedLink)) return 'https:' + normalizedLink;
        if (/^\//.test(normalizedLink)) return normalizedLink;

        // Accept plain domains like "example.com", "example.com/path", "example.com?x=1" by normalizing to https.
        if (/^[a-z0-9][a-z0-9.-]*\.[a-z]{2,}([/?#].*)?$/i.test(normalizedLink)) {
            return 'https://' + normalizedLink;
        }

        return null;
    }

    function hasStory(index) {
        return index >= 0 && index < storiesItems.length;
    }

    function hasNextStory() {
        return hasStory(currentStoryIndex + 1);
    }

    function hasPreviousStory() {
        return hasStory(currentStoryIndex - 1);
    }

    function isVideoStory(story) {
        return !!(story && story.video_url);
    }

    function isImageStory(story) {
        return !!(story && !story.video_url);
    }

    function getCurrentStory() {
        return storiesItems[currentStoryIndex] || null;
    }

    function clearImageStoryTimers() {
        if (imageProgressTimeoutId) {
            window.clearTimeout(imageProgressTimeoutId);
            imageProgressTimeoutId = null;
        }

        if (imageProgressFrameId) {
            window.cancelAnimationFrame(imageProgressFrameId);
            imageProgressFrameId = null;
        }
    }

    function clearVideoStoryBindings() {
        if (videoAudioProbeIntervalId) {
            window.clearInterval(videoAudioProbeIntervalId);
            videoAudioProbeIntervalId = null;
        }

        if (!activeVideoElement) return;

        jQuery(activeVideoElement).off('.sidebarStoriesVideo');
        activeVideoElement.pause();
        activeVideoElement = null;
        activeVideoHasAudioTrack = true;
    }

    function cleanupCurrentStoryPlayback() {
        clearImageStoryTimers();
        clearVideoStoryBindings();
        imageProgressElapsedMs = 0;
        imageProgressStartedAt = null;
    }

    function normalizeProgress(progressValue) {
        if (!Number.isFinite(progressValue)) return 0;
        if (progressValue <= 0) return 0;
        if (progressValue >= 1) return 1;
        return progressValue;
    }

    function setIndicatorProgress(progressValue) {
        var normalizedProgress = normalizeProgress(progressValue);

        indicatorsElement.find('.sidebar-stories-indicator').each(function() {
            var indicator = jQuery(this);
            var indicatorIndex = parseInt(indicator.attr('data-story-indicator-index'), 10);
            var fillElement = indicator.find('.sidebar-stories-indicator-fill');
            var fillProgress = 0;

            indicator.removeClass('is-active is-completed');

            if (indicatorIndex < currentStoryIndex) {
                indicator.addClass('is-completed');
                fillProgress = 1;
            } else if (indicatorIndex === currentStoryIndex) {
                indicator.addClass('is-active');
                fillProgress = normalizedProgress;
            }

            fillElement.css('width', (fillProgress * 100) + '%');
        });
    }

    function renderIndicators() {
        indicatorsElement.empty();

        storiesItems.forEach(function(_story, index) {
            indicatorsElement.append(
                '<span class="sidebar-stories-indicator" data-story-indicator-index="' + index + '">' +
                    '<span class="sidebar-stories-indicator-fill"></span>' +
                '</span>'
            );
        });

        setIndicatorProgress(0);
    }

    function setControlsVisibility() {
        previousButton.prop('disabled', !hasPreviousStory());
        nextButton.prop('disabled', !hasNextStory());
    }

    function updateVideoControlButtons() {
        var controls = mediaElement.find('.sidebar-stories-media-controls');
        if (!controls.length) return;

        var playPauseIcon = controls.find('[data-story-toggle-play] i');
        var audioButton = controls.find('[data-story-toggle-audio]');
        var audioIcon = controls.find('[data-story-toggle-audio] i');
        var isPlaying = activeVideoElement && !activeVideoElement.paused && !activeVideoElement.ended;

        playPauseIcon.attr('class', isPlaying ? 'fas fa-pause' : 'fas fa-play');
        audioButton.prop('disabled', !activeVideoHasAudioTrack);
        audioButton.toggleClass('d-none', !activeVideoHasAudioTrack);
        audioIcon.attr('class', !activeVideoHasAudioTrack || isSoundMuted ? 'fas fa-volume-mute' : 'fas fa-volume-up');
    }

    function detectVideoAudioTrack(videoElement, forceDecision) {
        if (!videoElement) return { determined: true, hasAudio: true };

        if (typeof videoElement.mozHasAudio === 'boolean') {
            return { determined: true, hasAudio: videoElement.mozHasAudio };
        }

        if (videoElement.audioTracks && typeof videoElement.audioTracks.length === 'number') {
            return { determined: true, hasAudio: videoElement.audioTracks.length > 0 };
        }

        if (typeof videoElement.webkitAudioDecodedByteCount === 'number') {
            if (videoElement.webkitAudioDecodedByteCount > 0) {
                return { determined: true, hasAudio: true };
            }

            if (forceDecision || videoElement.currentTime > 0.35 || videoElement.ended) {
                return { determined: true, hasAudio: false };
            }

            return { determined: false, hasAudio: false };
        }

        return { determined: true, hasAudio: true };
    }

    function updateVideoAudioTrackState(videoElement, forceDecision) {
        if (!videoElement) return;

        var detection = detectVideoAudioTrack(videoElement, !!forceDecision);
        if (!detection.determined) return;

        activeVideoHasAudioTrack = detection.hasAudio;
        updateVideoControlButtons();
    }

    function startVideoAudioTrackProbe(videoElement) {
        if (!videoElement) return;

        if (videoAudioProbeIntervalId) {
            window.clearInterval(videoAudioProbeIntervalId);
            videoAudioProbeIntervalId = null;
        }

        var attempts = 0;
        var maxAttempts = 30;

        var probe = function(forceDecision) {
            var detection = detectVideoAudioTrack(videoElement, !!forceDecision);
            if (!detection.determined) return false;

            activeVideoHasAudioTrack = detection.hasAudio;
            updateVideoControlButtons();
            return true;
        };

        if (probe(false)) return;

        videoAudioProbeIntervalId = window.setInterval(function() {
            attempts += 1;
            if (probe(attempts >= maxAttempts)) {
                window.clearInterval(videoAudioProbeIntervalId);
                videoAudioProbeIntervalId = null;
                return;
            }

            if (attempts >= maxAttempts) {
                window.clearInterval(videoAudioProbeIntervalId);
                videoAudioProbeIntervalId = null;
            }
        }, 100);
    }

    function renderStory() {
        var story = getCurrentStory();
        if (!story) return;
        markStoryAsViewed(story);
        resetStoryTextContrastClasses();
        updateContrastFromLuminance(storyBackgroundLuminance(story));

        var fallbackBackground = buildStoryBackground(story.background);

        frameElement.css('background', fallbackBackground || '#1a2233');
        mediaElement.empty();

        if (isVideoStory(story)) {
            mediaElement.append(
                '<video class="sidebar-stories-media-video" src="' + story.video_url + '" preload="metadata" playsinline></video>' +
                '<div class="sidebar-stories-media-controls">' +
                    '<button type="button" class="sidebar-stories-media-btn" data-story-toggle-audio aria-label="Toggle volume">' +
                        '<i class="fas fa-volume-up"></i>' +
                    '</button>' +
                    '<button type="button" class="sidebar-stories-media-btn" data-story-toggle-play aria-label="Toggle play and pause">' +
                        '<i class="fas fa-pause"></i>' +
                    '</button>' +
                '</div>'
            );
        } else if (story.image_url) {
            mediaElement.append('<img class="sidebar-stories-media-image" src="' + story.image_url + '" alt="">');
            sampleImageContrast(story);
        } else {
            mediaElement.append('<div class="sidebar-stories-media-fallback"></div>');
        }

        headlineElement.text(story.headline || '').toggle(!!story.headline);
        textElement.text(story.text || '').toggle(!!story.text);

        var storyLink = safeStoryLink(story.link);
        if (storyLink) {
            linkElement.attr('href', storyLink);
            linkElement.attr('target', '_blank');
            linkElement.text(story.link_text || 'Open');
            linkElement.prop('hidden', false);
        } else {
            linkElement.prop('hidden', true);
            linkElement.attr('href', '#');
            linkElement.removeAttr('target');
            linkElement.text('');
        }

        renderIndicators();
        setControlsVisibility();
    }

    function closeStoriesViewer() {
        cleanupCurrentStoryPlayback();
        isPausedByPointerHold = false;
        storiesViewer.prop('hidden', true).attr('aria-hidden', 'true');
        jQuery('body').removeClass('sidebar-stories-open');
    }

    function goToNextStoryOrClose() {
        if (hasNextStory()) {
            currentStoryIndex += 1;
            isPausedByUser = false;
            renderStory();
            startCurrentStoryPlayback();
            return;
        }

        closeStoriesViewer();
    }

    function goToPreviousStory() {
        if (!hasPreviousStory()) return;

        currentStoryIndex -= 1;
        isPausedByUser = false;
        renderStory();
        startCurrentStoryPlayback();
    }

    function goToNextStory() {
        if (!hasNextStory()) return;

        currentStoryIndex += 1;
        isPausedByUser = false;
        renderStory();
        startCurrentStoryPlayback();
    }

    function startImageStoryPlayback(resumeFromElapsed) {
        var elapsedAtStart = Number.isFinite(resumeFromElapsed) ? resumeFromElapsed : 0;
        imageProgressElapsedMs = Math.max(0, Math.min(imageStoryDurationMs, elapsedAtStart));
        imageProgressStartedAt = Date.now() - imageProgressElapsedMs;

        clearImageStoryTimers();

        var remainingDuration = Math.max(0, imageStoryDurationMs - imageProgressElapsedMs);
        imageProgressTimeoutId = window.setTimeout(function() {
            setIndicatorProgress(1);
            goToNextStoryOrClose();
        }, remainingDuration);

        function animateImageProgress() {
            if (!storiesViewer.is(':visible')) return;

            var elapsed = Date.now() - imageProgressStartedAt;
            imageProgressElapsedMs = Math.max(0, Math.min(imageStoryDurationMs, elapsed));
            setIndicatorProgress(imageProgressElapsedMs / imageStoryDurationMs);

            if (imageProgressElapsedMs >= imageStoryDurationMs) return;
            imageProgressFrameId = window.requestAnimationFrame(animateImageProgress);
        }

        animateImageProgress();
    }

    function pauseImageStoryPlayback() {
        if (!isImageStory(getCurrentStory())) return;

        if (imageProgressStartedAt) {
            imageProgressElapsedMs = Math.max(0, Math.min(imageStoryDurationMs, Date.now() - imageProgressStartedAt));
        }

        clearImageStoryTimers();
    }

    function setupVideoStoryPlayback() {
        activeVideoElement = mediaElement.find('video').get(0);
        if (!activeVideoElement) return;

        var videoElement = activeVideoElement;
        activeVideoHasAudioTrack = false;
        videoElement.loop = false;
        videoElement.muted = isSoundMuted;
        videoElement.defaultMuted = isSoundMuted;

        function syncVideoProgress() {
            if (!videoElement || !Number.isFinite(videoElement.duration) || videoElement.duration <= 0) {
                setIndicatorProgress(0);
                return;
            }

            setIndicatorProgress(videoElement.currentTime / videoElement.duration);
        }

        jQuery(videoElement)
            .off('.sidebarStoriesVideo')
            .on('loadedmetadata.sidebarStoriesVideo durationchange.sidebarStoriesVideo canplay.sidebarStoriesVideo timeupdate.sidebarStoriesVideo', function() {
                updateVideoAudioTrackState(videoElement, false);
                sampleVideoContrast(videoElement);
                syncVideoProgress();
            })
            .on('play.sidebarStoriesVideo pause.sidebarStoriesVideo', function() {
                updateVideoControlButtons();
            })
            .on('ended.sidebarStoriesVideo', function() {
                setIndicatorProgress(1);
                goToNextStoryOrClose();
            });

        if (videoElement.audioTracks && typeof videoElement.audioTracks.addEventListener === 'function') {
            videoElement.audioTracks.addEventListener('addtrack', function() {
                updateVideoAudioTrackState(videoElement, true);
            });
            videoElement.audioTracks.addEventListener('removetrack', function() {
                updateVideoAudioTrackState(videoElement, true);
            });
        }

        setIndicatorProgress(0);
        startVideoAudioTrackProbe(videoElement);
        updateVideoControlButtons();

        var autoplayPromise = videoElement.play();
        if (autoplayPromise && typeof autoplayPromise.catch === 'function') {
            autoplayPromise.catch(function() {
                // Browser blocked autoplay with sound; keep controls visible for manual start.
                isPausedByUser = true;
                updateVideoControlButtons();
            });
        }
    }

    function startCurrentStoryPlayback() {
        cleanupCurrentStoryPlayback();

        var story = getCurrentStory();
        if (!story) return;

        if (isVideoStory(story)) {
            setupVideoStoryPlayback();
        } else {
            startImageStoryPlayback(0);
        }
    }

    function openStoriesViewer(index) {
        if (!hasStory(index)) return;

        currentStoryIndex = index;
        isPausedByUser = false;
        isPausedByVisibility = false;

        storiesViewer.prop('hidden', false).attr('aria-hidden', 'false');
        jQuery('body').addClass('sidebar-stories-open');

        renderStory();
        startCurrentStoryPlayback();
    }

    function pauseCurrentStoryByVisibility() {
        if (storiesViewer.prop('hidden')) return;

        isPausedByVisibility = true;

        var story = getCurrentStory();
        if (isVideoStory(story) && activeVideoElement && !activeVideoElement.paused) {
            activeVideoElement.pause();
        }

        if (isImageStory(story)) {
            pauseImageStoryPlayback();
        }
    }

    function resumeCurrentStoryByVisibility() {
        if (storiesViewer.prop('hidden') || !isPausedByVisibility) return;

        var story = getCurrentStory();
        if (!story) return;

        isPausedByVisibility = false;

        if (isVideoStory(story) && activeVideoElement && !isPausedByUser) {
            activeVideoElement.play().catch(function() {
                isPausedByUser = true;
                updateVideoControlButtons();
            });
            return;
        }

        if (isImageStory(story)) {
            startImageStoryPlayback(imageProgressElapsedMs);
        }
    }

    function resetPointerHoldState() {
        pointerHoldState.pointerId = null;
        pointerHoldState.startTimeMs = 0;
        pointerHoldState.startX = 0;
        pointerHoldState.startY = 0;
        pointerHoldState.shouldResume = false;
    }

    function isInsideMediaControls(target) {
        return jQuery(target).closest('.sidebar-stories-media-controls').length > 0;
    }

    function isInteractiveFrameTarget(target) {
        var node = jQuery(target);
        if (!node.length) return false;
        if (isInsideMediaControls(target)) return true;
        if (node.closest('.sidebar-stories-link').length > 0) return true;
        if (node.closest('a, button, input, select, textarea, label').length > 0) return true;
        return false;
    }

    function pauseCurrentStoryByPointerHold() {
        if (storiesViewer.prop('hidden')) return;

        var story = getCurrentStory();
        if (!story) return;

        if (isVideoStory(story)) {
            pointerHoldState.shouldResume = !!(activeVideoElement && !activeVideoElement.paused && !isPausedByVisibility);
            if (pointerHoldState.shouldResume) {
                activeVideoElement.pause();
                isPausedByPointerHold = true;
            }
            return;
        }

        if (isImageStory(story)) {
            pointerHoldState.shouldResume = !isPausedByVisibility;
            if (pointerHoldState.shouldResume) {
                pauseImageStoryPlayback();
                isPausedByPointerHold = true;
            }
        }
    }

    function resumeCurrentStoryByPointerHold() {
        if (!isPausedByPointerHold) return;

        var story = getCurrentStory();
        if (!story) {
            isPausedByPointerHold = false;
            return;
        }

        if (isVideoStory(story)) {
            if (!isPausedByUser && !isPausedByVisibility && pointerHoldState.shouldResume && activeVideoElement) {
                activeVideoElement.play().catch(function() {
                    isPausedByUser = true;
                }).finally(function() {
                    updateVideoControlButtons();
                });
            }
            isPausedByPointerHold = false;
            return;
        }

        if (isImageStory(story) && !isPausedByVisibility && pointerHoldState.shouldResume) {
            startImageStoryPlayback(imageProgressElapsedMs);
        }

        isPausedByPointerHold = false;
    }

    storiesTrigger.off('click.sidebarStories').on('click.sidebarStories', function(event) {
        event.preventDefault();
        openStoriesViewer(nextOpenStoryIndex());
    });

    storiesViewer.find('[data-sidebar-stories-close]').off('click.sidebarStories').on('click.sidebarStories', function(event) {
        event.preventDefault();
        closeStoriesViewer();
    });

    previousButton.off('click.sidebarStories').on('click.sidebarStories', function(event) {
        event.preventDefault();
        goToPreviousStory();
    });

    nextButton.off('click.sidebarStories').on('click.sidebarStories', function(event) {
        event.preventDefault();
        goToNextStory();
    });

    storiesViewer.off('click.sidebarStoriesControls', '[data-story-toggle-audio]').on('click.sidebarStoriesControls', '[data-story-toggle-audio]', function(event) {
        event.preventDefault();
        if (!activeVideoHasAudioTrack) return;

        isSoundMuted = !isSoundMuted;
        if (activeVideoElement) {
            activeVideoElement.muted = isSoundMuted;
            activeVideoElement.defaultMuted = isSoundMuted;
        }

        updateVideoControlButtons();
    });

    storiesViewer.off('click.sidebarStoriesControls', '[data-story-toggle-play]').on('click.sidebarStoriesControls', '[data-story-toggle-play]', function(event) {
        event.preventDefault();

        if (!activeVideoElement) return;

        if (activeVideoElement.paused || activeVideoElement.ended) {
            isPausedByUser = false;
            activeVideoElement.play().catch(function() {
                isPausedByUser = true;
            }).finally(function() {
                updateVideoControlButtons();
            });
            return;
        }

        isPausedByUser = true;
        activeVideoElement.pause();
        updateVideoControlButtons();
    });

    function handleStoryLinkInteraction(event) {
        var storyLinkHref = jQuery(this).attr('href');
        if (!storyLinkHref || storyLinkHref === '#') {
            event.preventDefault();
            event.stopPropagation();
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        var targetValue = jQuery(this).attr('target') || '_blank';
        var openedWindow = window.open(storyLinkHref, targetValue, 'noopener,noreferrer');
        if (!openedWindow && targetValue === '_self') {
            window.location.assign(storyLinkHref);
        }
    }

    linkElement.off('pointerdown.sidebarStoriesLink click.sidebarStoriesLink')
        .on('pointerdown.sidebarStoriesLink', function(event) {
            event.stopPropagation();
        })
        .on('click.sidebarStoriesLink', handleStoryLinkInteraction);

    storiesViewer.off('click.sidebarStoriesLink', '[data-sidebar-stories-link]')
        .on('click.sidebarStoriesLink', '[data-sidebar-stories-link]', handleStoryLinkInteraction);

    frameElement.off('pointerdown.sidebarStories pointerup.sidebarStories pointercancel.sidebarStories').on('pointerdown.sidebarStories', function(event) {
        if (storiesViewer.prop('hidden')) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (isInteractiveFrameTarget(event.target)) return;

        pointerHoldState.pointerId = event.pointerId;
        pointerHoldState.startTimeMs = Date.now();
        pointerHoldState.startX = event.clientX;
        pointerHoldState.startY = event.clientY;
        pointerHoldState.shouldResume = false;

        pauseCurrentStoryByPointerHold();

        if (event.currentTarget && typeof event.currentTarget.setPointerCapture === 'function') {
            try {
                event.currentTarget.setPointerCapture(event.pointerId);
            } catch (_error) {
                console.warn('Story interaction fallback was used.', _error);
            }
        }
    }).on('pointerup.sidebarStories', function(event) {
        if (pointerHoldState.pointerId !== event.pointerId) return;

        var durationMs = Date.now() - pointerHoldState.startTimeMs;
        var deltaX = Math.abs(event.clientX - pointerHoldState.startX);
        var deltaY = Math.abs(event.clientY - pointerHoldState.startY);
        var hasMoved = deltaX > POINTER_TAP_MOVE_THRESHOLD_PX || deltaY > POINTER_TAP_MOVE_THRESHOLD_PX;
        var isHold = durationMs >= POINTER_HOLD_THRESHOLD_MS;
        var shouldNavigate = !hasMoved && !isHold && !isInteractiveFrameTarget(event.target);

        resumeCurrentStoryByPointerHold();

        if (shouldNavigate) {
            var frameRect = event.currentTarget.getBoundingClientRect();
            var isLeftHalf = (event.clientX - frameRect.left) < (frameRect.width / 2);
            if (isLeftHalf) {
                goToPreviousStory();
            } else {
                goToNextStory();
            }
        }

        resetPointerHoldState();
    }).on('pointercancel.sidebarStories', function(event) {
        if (pointerHoldState.pointerId !== event.pointerId) return;
        resumeCurrentStoryByPointerHold();
        resetPointerHoldState();
    });

    jQuery(document).off('keydown.sidebarStories').on('keydown.sidebarStories', function(event) {
        if (storiesViewer.prop('hidden')) return;

        if (event.key === 'Escape') {
            closeStoriesViewer();
            return;
        }

        if (event.key === 'ArrowRight') {
            goToNextStory();
            return;
        }

        if (event.key === 'ArrowLeft') {
            goToPreviousStory();
        }
    });

    jQuery(document).off('visibilitychange.sidebarStories').on('visibilitychange.sidebarStories', function() {
        if (document.hidden) {
            pauseCurrentStoryByVisibility();
            return;
        }

        resumeCurrentStoryByVisibility();
    });
});
